import { solutions } from '../../data/content';
import './Solutions.css';

function Solutions() {
  return (
    <section id="solucoes" className="section solutions">
      <div className="container">
        <div className="section-header">
          <h2>Soluções</h2>
          <p>Cada solução é pensada para resolver um problema real do seu negócio.</p>
        </div>

        <div className="solutions-grid">
          {solutions.map((item) => (
            <div key={item.title} className="solution-card">
              <span className="solution-icon">{item.icon}</span>
              <span className="solution-category">{item.title}</span>
              <h3>{item.headline}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Solutions;
